import React, { Component } from "react";
import regeneratorRuntime from "regenerator-runtime"; // eslint-disable-line
import PropTypes from "prop-types";

import camera from "assets/graphics/icons/camera.png";

import AboutView from "features/application/about/view";

class About extends Component {
  constructor(props) {
    super(props);

    this.state = {
      src: null,
      crop: {
        unit: "%",
        width: 100,
        aspect: 1,
      },
      imageRef: null,
      croppedImageUrl: camera,
      previewVisibility: false,
      photoError: null,
    };

    this.references = {
      photo: React.createRef(),
      instagram: React.createRef(),
      instagramNotApplicable: React.createRef(),
      linkedin: React.createRef(),
      linkedinNotApplicable: React.createRef(),
      autobiography: React.createRef(),
    };

    this.changeVisibility = this.changeVisibility.bind(this);
    this.onSelectFile = this.onSelectFile.bind(this);
    this.onImageLoaded = this.onImageLoaded.bind(this);
    this.onCropComplete = this.onCropComplete.bind(this);
    this.onCropChange = this.onCropChange.bind(this);
    this.makeClientCrop = this.makeClientCrop.bind(this);
    this.checkPhotoField = this.checkPhotoField.bind(this);
  }

  ///////////////////////////////

  changeVisibility() {
    this.setState({ previewVisibility: false });
  }

  onSelectFile(e) {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      const img = new Image();

      reader.addEventListener("load", () => {
        img.src = reader.result;

        img.onload = () => {
          if (img.width >= 400 && img.height >= 400) {
            this.setState({
              src: reader.result,
              previewVisibility: true,
              photoError: null,
            });
          } else {
            this.setState({
              photoError: "Photo should be greater than 400px width and height",
            });

            this.checkPhotoField();
          }
        };
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  }

  onImageLoaded(image) {
    const percentageWidth = (1000 / image.naturalWidth) * 100;

    this.setState({
      imageRef: image,
      crop: {
        aspect: 1,
        unit: "%",
        width: percentageWidth,
      },
    });
  }

  async onCropComplete() {
    await this.makeClientCrop(this.state.crop);
  }

  onCropChange(crop, percentCrop) {
    const cropWidth = Math.round(
      (this.state.imageRef?.naturalWidth * percentCrop.width) / 100
    );

    if (cropWidth >= 400) {
      this.setState({ crop: percentCrop });
    }
  }

  async makeClientCrop(crop) {
    if (this.state.imageRef && crop.width && crop.height) {
      const croppedImageUrl = await this.getCroppedImg(
        this.state.imageRef,
        crop
      );
      this.setState({ croppedImageUrl });
    }
  }

  getCroppedImg(image, crop) {
    const canvas = document.createElement("canvas");
    canvas.width = Math.round((crop.width * image.naturalWidth) / 100);
    canvas.height = Math.round((crop.height * image.naturalHeight) / 100);
    const ctx = canvas.getContext("2d");

    const sx = Math.round((crop.x * image.naturalWidth) / 100);
    const sy = Math.round((crop.y * image.naturalHeight) / 100);

    const sw = Math.round((crop.width * image.naturalWidth) / 100);
    const sh = Math.round((crop.height * image.naturalHeight) / 100);

    const dw = Math.round((crop.width * image.naturalWidth) / 100);
    const dh = Math.round((crop.height * image.naturalHeight) / 100);

    ctx.drawImage(image, sx, sy, sw, sh, 0, 0, dw, dh);

    return new Promise((resolve) => {
      resolve(canvas.toDataURL("image/jpeg"));
    });
  }

  ///////////////////////////////

  componentDidMount() {
    const { userData } = this.props;

    if (userData.avatar_file) {
      let image = new Image();
      let canvas = document.createElement("canvas");
      let context = canvas.getContext("2d");

      image.crossOrigin = "Anonymous";
      image.src = userData.avatar_file;

      image.onload = () => {
        canvas.width = image.width;
        canvas.height = image.height;
        context.drawImage(image, 0, 0);

        this.setState({ croppedImageUrl: canvas.toDataURL() });
      };
    }

    if (
      this.references.instagram.current &&
      this.references.linkedin.current &&
      this.references.instagramNotApplicable.current &&
      this.references.linkedinNotApplicable.current
    ) {
      let instagram = this.references.instagram.current;
      let linkedin = this.references.linkedin.current;
      let instagramNotApplicable = this.references.instagramNotApplicable
        .current;
      let linkedinNotApplicable = this.references.linkedinNotApplicable.current;

      instagram.addEventListener("input", () =>
        this.uncheckInstagramNotApplicable()
      );
      linkedin.addEventListener("input", () =>
        this.uncheckLinkedinNotApplicable()
      );
      instagramNotApplicable.addEventListener("change", () =>
        this.clearInstagramField()
      );
      linkedinNotApplicable.addEventListener("change", () => {
        this.clearLinkedinField();
      });
    }
  }

  componentWillUnmount() {
    if (
      this.references.instagram.current &&
      this.references.linkedin.current &&
      this.references.instagramNotApplicable.current &&
      this.references.linkedinNotApplicable.current
    ) {
      let instagram = this.references.instagram.current;
      let linkedin = this.references.linkedin.current;
      let instagramNotApplicable = this.references.instagramNotApplicable
        .current;
      let linkedinNotApplicable = this.references.linkedinNotApplicable.current;

      instagram.removeEventListener("input", () =>
        this.uncheckInstagramNotApplicable()
      );
      linkedin.removeEventListener("input", () =>
        this.uncheckLinkedinNotApplicable()
      );
      instagramNotApplicable.removeEventListener("change", () =>
        this.clearInstagramField()
      );
      linkedinNotApplicable.removeEventListener("change", () =>
        this.clearLinkedinField()
      );
    }
  }

  uncheckInstagramNotApplicable() {
    let instagramNotApplicable = this.references.instagramNotApplicable.current;

    if (instagramNotApplicable.checked) {
      instagramNotApplicable.checked = false;

      this.checkFields();
    }
  }

  uncheckLinkedinNotApplicable() {
    let linkedinNotApplicable = this.references.linkedinNotApplicable.current;

    if (linkedinNotApplicable.checked) {
      linkedinNotApplicable.checked = false;
      this.checkFields();
    }
  }

  clearInstagramField() {
    let instagram = this.references.instagram.current;
    let instagramNotApplicable = this.references.instagramNotApplicable.current;

    instagramNotApplicable.checked && (instagram.value = "");
  }

  clearLinkedinField() {
    let linkedin = this.references.linkedin.current;
    let linkedinNotApplicable = this.references.linkedinNotApplicable.current;

    linkedinNotApplicable.checked && (linkedin.value = "");
  }

  // EVERYTHING HERE SHOULD BE REWRITTEN!

  checkPhotoField() {
    const photoField = this.references.photo.current;
    const blurEvent = new Event("blur", { bubbles: true, cancelable: true });

    photoField && photoField.dispatchEvent(blurEvent);
  }

  checkFields(notChecking) {
    let instagram = this.references.instagram.current;
    let linkedin = this.references.linkedin.current;
    let autobiography = this.references.autobiography.current;
    let blurEvent = new Event("blur", { bubbles: true, cancelable: true });

    instagram &&
      notChecking !== "instagram" &&
      instagram.dispatchEvent(blurEvent);

    linkedin && notChecking !== "linkedin" && linkedin.dispatchEvent(blurEvent);

    autobiography && autobiography.dispatchEvent(blurEvent);
  }

  render() {
    const {
      errorCodes,
      userData,
      backToPreviousStep,
      sendApiRequest,
    } = this.props;

    return (
      <AboutView
        errorCodes={errorCodes}
        userData={userData}
        references={this.references}
        backToPreviousStep={backToPreviousStep}
        sendApiRequest={sendApiRequest}
        onSelectFile={this.onSelectFile}
        crop={this.state.crop}
        src={this.state.src}
        onImageLoaded={this.onImageLoaded}
        onCropComplete={this.onCropComplete}
        onCropChange={this.onCropChange}
        croppedImageUrl={this.state.croppedImageUrl}
        changeVisibility={this.changeVisibility}
        previewVisibility={this.state.previewVisibility}
        photoError={this.state.photoError}
      />
    );
  }
}

About.propTypes = {
  errorCodes: PropTypes.object,
  userData: PropTypes.object,
  backToPreviousStep: PropTypes.func,
  sendApiRequest: PropTypes.func,
  photoError: PropTypes.string,
};

export default About;
